"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MEDIA_ITEM_SKELETON = void 0;
const MEDIA_ITEM_SKELETON = exports.MEDIA_ITEM_SKELETON = 'media-item-skeleton';
